import type { Configuration, RedirectRequest } from '@azure/msal-browser'
import { LogLevel } from '@azure/msal-browser'
import { env, IS_DEV } from '@/lib/env'

/**
 * MSAL configuration for Pulse v2.
 *
 * Redirect flow (not popup) — matches Central's pattern. Silent iframe points
 * at `/auth/blank.html` so refresh doesn't remount the React tree. Cache lives
 * in `localStorage` so a reload / new tab keeps the operator signed in.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: env.VITE_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${env.VITE_MSAL_TENANT_ID}`,
    redirectUri: env.VITE_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: env.VITE_MSAL_REDIRECT_URI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    iframeHashTimeout: 10_000,
    windowHashTimeout: 60_000,
    loggerOptions: {
      loggerCallback(level, message, containsPii) {
        if (containsPii || !IS_DEV) return
        if (level === LogLevel.Error) console.error('[msal]', message)
      },
      piiLoggingEnabled: false,
      logLevel: IS_DEV ? LogLevel.Warning : LogLevel.Error,
    },
  },
}

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
}

/**
 * Vision-scope silent request. `aud=api://vision-ui` is enforced by
 * `SecurityConfig.ENTRA_AUDIENCE` in Vision — the token minted for this scope
 * is the one Pulse routes accept. Value is the App ID URI of the Vision API
 * app registration in the Boldfit Tech tenant.
 */
export const visionSilentRequest = {
  scopes: [env.VITE_VISION_API_SCOPE],
}
